import React from "react";
import { Col, Row, Layout, Icon, Typography } from "antd";
import { footerText } from "util/config";
import moment from "moment";
import { Link } from "react-router-dom";
import './style.less';

const { Footer } = Layout;
const { Title } = Typography;
const year = moment().format("YYYY");

const Portal = (props) => {
  const setLoginType = (type) => {
    localStorage.setItem('loged_in_to', type)
    localStorage.setItem('skipStep', false)
  }

  const partnerLogin = (type) => {
    localStorage.setItem('loged_in_to', type)
    localStorage.setItem('user_role', 'partner')
  }

  const portalSections = [
    {
      title: "Uniserved",
      titleColor: "#630086",
      items: [
        { 
          label: "Project Management", 
          link: "/signin?type=pmt", 
          icon: "appstore", 
          onClick: () => setLoginType("pmt"),
          color: "#630086"
        },
        { 
          label: "Partner Management", 
          link: "/signin?type=orion", 
          icon: "team", 
          onClick: () => setLoginType("orion"),
          color: "#630086"
        },
        { 
          label: "Finance Central", 
          link: "/signin?type=fc", 
          icon: "wallet", 
          onClick: () => setLoginType("fc"),
          color: "#630086"
        }
      ]
    },
    {
      title: "Client",
      titleColor: "#ff9800",
      items: [
        { 
          label: "Client Portal", 
          link: "/signin?type=customer", 
          icon: "user", 
          onClick: () => setLoginType("pmt"),
          color: "#ff9800"
        }
      ]
    },
    {
      title: "Partner",
      titleColor: "#009688",
      items: [
        { 
          label: "Partner Login", 
          link: "/partner-login", 
          icon: "key", 
          onClick: () => partnerLogin("orion"),
          color: "#009688"
        },
        { 
          label: "Partner Mobile App", 
          link: "https://play.google.com/store/apps/details?id=com.uniserved", 
          icon: "mobile", 
          external: true,
          color: "#009688"
        }
      ]
    },
    {
      title: "Engineer",
      titleColor: "#e91e63",
      items: [
        { 
          label: "Engineer Mobile App", 
          link: "https://play.google.com/store/apps/details?id=com.uniserved", 
          icon: "mobile", 
          external: true,
          color: "#e91e63"
        }
      ]
    }
  ];

  return (
    <div className="modern-portal-wrapper">
      <div className="modern-portal-container">
        <div className="modern-portal-header">
          <img src={require('assets/images/Uniserved-Logo-square-for-dark-bg.png')} alt="Uniserved Logo" className="modern-portal-logo" />
          <Title level={1} className="modern-portal-main-title">Welcome to Matrix</Title>
          <p className="modern-portal-subtitle">Choose your portal to get started</p>
        </div>

        <Row gutter={[24, 24]} className="modern-portal-grid">
          {portalSections.map((section, sectionIndex) => (
            <Col 
              xl={6} 
              lg={6} 
              md={12} 
              sm={24} 
              xs={24} 
              key={sectionIndex}
            >
              <div className="modern-portal-card">
                <div className="modern-portal-card-header" style={{ borderTopColor: section.titleColor }}>
                  <Title level={3} className="modern-portal-card-title" style={{ color: section.titleColor }}>
                    {section.title}
                  </Title>
                </div>
                <div className="modern-portal-card-body">
                  {section.items.map((item, itemIndex) => {
                    const content = (
                      <div className="modern-portal-item">
                        <div className="modern-portal-item-icon" style={{ backgroundColor: `${item.color}15` }}>
                          <Icon type={item.icon} style={{ color: item.color, fontSize: 24 }} />
                        </div>
                        <span className="modern-portal-item-label">{item.label}</span>
                        <Icon type="right" className="modern-portal-item-arrow" />
                      </div>
                    );

                    if (item.external) {
                      return (
                        <a
                          key={itemIndex}
                          href={item.link}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="modern-portal-link"
                          style={{ borderLeftColor: item.color }}
                        >
                          {content}
                        </a>
                      );
                    }

                    return (
                      <Link
                        key={itemIndex}
                        to={item.link}
                        onClick={item.onClick}
                        className="modern-portal-link"
                        style={{ borderLeftColor: item.color }}
                      >
                        {content}
                      </Link>
                    );
                  })}
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </div>

      <Footer className="modern-portal-footer">
        <p className="modern-portal-footer-text">
          {footerText}{year}
        </p>
      </Footer>
    </div>
  );
};

export default Portal;